module.exports = __webpack_public_path__ + "img/taskbar.35119ace.png";